export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openRoleForm({commit}) {
        commit('setRoleFormOpen');
    },
    closeRoleForm({commit}) {
        commit('setRoleFormClose');
    },
    openPermissionGrid({commit}) {
        commit('setPermissionFormClose');
    },
    openPermissionForm({commit}) {
        commit('setPermissionFormOpen');
    },
    closePermissionForm({commit}) {
        commit('setPermissionFormClose');
    }
}
